import * as React from "react"
import { LogoSkeleton, LogoProps } from "./skeleton"

export function SanityLogo(props: LogoProps) {
  return (
    <LogoSkeleton {...props} logoName="SanityLogo">
      <ellipse
        cx="10.0002"
        cy="9.99967"
        rx="9.16697"
        ry="9.16667"
        fill="#FF4433"
      />
      <path
        opacity="0.6"
        d="M12.4344 11.8545C13.2934 12.4021 13.6824 13.1752 13.6824 14.2865C12.9531 15.2045 11.7051 15.7038 10.2303 15.7038C7.75064 15.7038 5.98409 14.4797 5.61133 12.3699H7.99375C8.30168 13.3362 9.11202 13.7872 10.2141 13.7872C11.5269 13.8033 12.4182 13.0946 12.4344 11.8545Z"
        fill="white"
      />
      <path
        opacity="0.6"
        d="M7.78295 8.02171C6.97261 7.53853 6.50261 6.66882 6.53502 5.73468C7.23192 4.83275 8.43123 4.28516 9.88985 4.28516C12.4343 4.28516 13.893 5.62194 14.2657 7.49021H11.9643C11.705 6.74935 11.073 6.16954 9.92227 6.16954C8.67434 6.18564 7.83158 6.8943 7.78295 8.02171Z"
        fill="white"
      />
      <path
        d="M6.535 5.75098C6.535 7.28103 7.49121 8.19906 9.40362 8.68223L11.4295 9.1493C13.2447 9.56805 14.3467 10.5988 14.3467 12.2738C14.3629 12.9986 14.1198 13.7072 13.6823 14.2871C13.6823 12.6121 12.8071 11.7101 10.7164 11.1625L8.72293 10.7116C7.11845 10.3572 5.88672 9.50363 5.88672 7.68367C5.88672 6.99112 6.11362 6.29857 6.535 5.75098Z"
        fill="white"
      />
    </LogoSkeleton>
  )
}
